import { graph, branch, memberKey } from '../constants'

module.exports = () ->
  onMainBranch = await new Weaver.Query()
    .inGraph('$config')
    .hasRelationOut('type')
    .find()

  if onMainBranch.length is 0
    return

  onConfigBranch = await new Weaver.Query(undefined, branch)
    .inGraph('$config')
    .hasRelationOut('type')
    .find()

  result = onMainBranch.filter((node) => onConfigBranch.find((_node) => _node.id() is node.id()))

  Promise.map(result, (node) ->
    typeId = node.relation(memberKey).first().id()
    try
      type = await new Weaver.Query(undefined, branch).restrict(typeId).first()
    catch
      type = undefined

    if type?
      try
        nodeToMigrate = await new Weaver.Query(undefined, branch).restrict(node.id()).first()
      catch
        nodeToMigrate = new Weaver.Node(node.id())
        nodeToMigrate.relation(memberKey).add(type)

      _.map(node.attributes(), (attribute, key) ->
        nodeToMigrate.set(key, attribute)
      )

      nodeToMigrate.save({ branch, commitMessage: "Graph -> Branch migration." })
    else
      Promise.resolve()
  )

  Weaver.Node.batchDestroy(onMainBranch)
